import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

const resources = {
  en: {
    translation: {
      common: {
        cancelLabel: "Cancel",
        deleteLabel: "Delete",
        shiftCountLabel_one: "{{count}} shift",
        shiftCountLabel_other: "{{count}} shifts",
        amendmentCountLabel_one: "{{count}} amendment",
        amendmentCountLabel_other: "{{count}} amendments",
        deductionCountLabel_one: "{{count}} deduction",
        deductionCountLabel_other: "{{count}} deductions",
        additionCountLabel_one: "{{count}} addition",
        additionCountLabel_other: "{{count}} additions",
        noShiftHistoryMessage: "No shift history available",
        shiftTableColumns: {
          date: "Date",
          performingTime: "Performing Time",
          service: "Service",
          totalHours: "Total Hours",
          totalHoursTooltip: "Total hours including check-in",
          amendments: "Amendments",
          notes: "Notes"
        }
      },
      shiftAdminAddAmendmentDialog: {
        addAmendmentLabel: "Add Amendment",
        creatingAmendment: "Creating amendment...",
        form: {
          amendmentScope: "Amendment Scope",
          shift: "Shift",
          noShiftsAvailable: "No shifts available for selected day",
          amendmentType: "Amendment Type",
          direction: "Direction",
          deduction: "Deduction",
          addition: "Addition",
          incidentTime: "Incident Time",
          duration: "Duration",
          unit: "Unit",
          durationUnitMinutes: "min",
          durationUnitHours: "hrs",
          reasonOrNote: "Reason / Note",
          reasonOrNotePlaceholder: "Required - explain the reason for this amendment",
          scope: {
            attached: {
              label: "Attached",
              tooltip: "Attached to a shift"
            },
            standalone: {
              label: "Standalone",
              tooltip: "Standalone amendment"
            }
          },
          amendmentTypes: {
            ABSENCE: "Absence",
            EMERGENCY: "Emergency",
            LATE_ARRIVAL: "Late Arrival",
            MEETING: "Meeting",
            OTHER: "Other",
            OVERTIME: "Overtime",
            TECHNICAL_ISSUE: "Technical Issue",
            TRAINING: "Training"
          }
        }
      },
      shiftAdmin: {
        toolbar: {
          monthView: "Month",
          dayView: "Day",
          servicesFilterLabel: "Services",
          allServicesOption: "All services",
          allPerformersOption: "All performers",
          exportReport: "Export report"
        },
        grid: {
          performerColumn: "Performer",
          serviceColumn: "Service",
          shiftsColumn: "Shifts",
          totalHoursColumn: "Total Hrs",
          amendmentsColumn: "Amendments",
          actionColumn: "Action",
          noMonthRows: "No performers with completed shifts this month.",
          noDayRows: "No performers scheduled for this day."
        },
        performerShiftSummaryDialog: {
          monthAndShiftCount_one: "{{monthYear}} {{count}} shift",
          monthAndShiftCount_other: "{{monthYear}} {{count}} shifts",
          closeLabel: "Close"
        }
      },
      schedulePlanner: {
        toolbar: {
          addShiftPlan: "+Add Shift Plan"
        }
      },
      myHistoryView: {
        shiftHistory: "Shift History",
        sessionHistory: "Session History"
      },
      shiftAdminPerformerAmendmentsDialog: {
        card: {
          shift: "Shift",
          addedBy: "Added by",
          addedOn: "Added on"
        }
      },
      myHistory: {
        shifts: {
          summary: {
            month: "Month",
            totalShifts: "Total Shifts",
            totalHours: "Total Hours",
            totalHoursDescription: "Inc amendments + check-in",
            amendments: "Amendments"
          }
        }
      },
      deleteAmendmentDialog: {
        title: "Delete Amendment",
        confirmationMessage: "Are you sure you want to delete this amendment?",
        deletingAmendment: "Deleting amendment...",
        deleteFailed: "Failed to delete amendment."
      },
      swapSessionRules: {
        BOOKABLE_SERVICES_OF_SHIFTS_ARE_MATCHING: {
          pass: "Shift's bookable services match",
          fail: "Shift's bookable services do not match"
        },
        TARGET_PERFORMER_TIMESLOT_IS_BOOKABLE: {
          pass: "<0>{{targetPerformerName}}</0>'s slot is bookable",
          fail: "<0>{{targetPerformerName}}</0>'s slot is unbookable"
        },
        TARGET_PERFORMER_IS_ACCREDITED: {
          pass: "<0>{{targetPerformerName}}</0> is accredited for <0>{{sourcePerformerName}}</0>'s content",
          fail: "<0>{{targetPerformerName}}</0> is <0>not</0> accredited for <0>{{sourcePerformerName}}</0>'s content"
        },
        SOURCE_PERFORMER_IS_ACCREDITED: {
          pass: "<0>{{sourcePerformerName}}</0> is accredited for <0>{{targetPerformerName}}</0>'s content",
          fail: "<0>{{sourcePerformerName}}</0> is <0>not</0> accredited for <0>{{targetPerformerName}}</0>'s content"
        }
      }
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false // react already safes from xss
  },
});

export default i18n;